import NotificationApiClass, { filtersWithPagination } from 'SharedDir/backend/api/classes/NotificationApiClass';
import { NNotification } from 'SharedDir/declarations/notification';
import { WafError } from 'SharedDir/declarations/shared';
import { defineStore } from 'pinia';

export interface NotificationStateInterface {
  collapseNotificationModal: boolean;
  unreadNotifications: NNotification.NotificationList;
  wafError: WafError;
}

export const useNotificationStore = defineStore('notification', {
  persist: false,

  state: (): NotificationStateInterface => ({
    collapseNotificationModal: false,
    unreadNotifications: [],
    wafError: {
      id: '',
      content: '',
      url: '',
    },
  }),

  getters: {
    getNotificationModalStatus: (state): boolean => state.collapseNotificationModal,
    getUnreadNotifications: (state): NNotification.NotificationList => state.unreadNotifications,
    getCountUnreadNotifications: (state): number => state.unreadNotifications.length,
    getWafError: (state) => state.wafError,
  },

  actions: {
    setNotificationModal(val: boolean) {
      this.collapseNotificationModal = val;
    },

    async fetchUnreadNotifications() {
      const unreadNotifications = (
        await NotificationApiClass.getList(filtersWithPagination)
      ).messages;
      this.unreadNotifications = unreadNotifications;
    },

    async setNotificationAsReaded(notificationIds: NNotification.NotificationUidList) {
      await NotificationApiClass.markRead(notificationIds);
      notificationIds.forEach((notificationId) => {
        const notificationIndex = this.unreadNotifications.findIndex(
          (n) => n.id === notificationId
        );
        if (notificationIndex !== -1) {
          this.unreadNotifications.splice(notificationIndex, 1);
        }
      });
    },

    async setAllNotificationsAsReaded() {
      await NotificationApiClass.markAllRead();
      this.unreadNotifications = [];
    },

    setWafError(error: WafError) {
      this.wafError = error;
    },

    resetWafError() {
      this.wafError = { id: '', content: '', url: '' };
    },
  }
});
